module.exports = __webpack_public_path__ + "static/img/WAIDAZFEELER.eb283250.png";